import useRanger from "./useRanger";

export default useRanger;
